import { UserType } from 'api'

export namespace permissions {
  export const canViewBilling: UserType[] = [UserType.OWNER, UserType.DEBUG]
}

export default permissions
